import {
    Box,
    Chip,
    Grid,
    ListItemIcon,
    MenuItem,
    Typography,
  } from "@mui/material";
  import CustomDropDown from "../../../../components/CutomDropDown";
  import CheckIcon from "@mui/icons-material/Check";
  import { useSelector } from "react-redux";
  import Label from "../../../../components/Label";
  import { useTranslation } from "react-i18next";
  
  export const Tags = ({
    inputValues,
    inputError,
    handleChangeInputValue,
    handleDeleteTag,
    allEcommerceTags,
  }) => {
    const { t } = useTranslation();
    const { currentLanguage } = useSelector((state) => state.translationReducer);
  
    return (
      <Box my={2}>
        <Typography fontWeight={600} fontSize={20} mb={2}>
          {t("supplierProductTab.chooseAMatchFit")}
        </Typography>
  
        <Label
          labelText={t("supplierProductTab.selectMultipleMatchFit")}
          required
          htmlFor={"base-package-tags"}
        />
  
        <CustomDropDown
          id={"base-package-tags"}
          name="tags"
          value={inputValues.tags}
          onChange={handleChangeInputValue}
          selectError={Boolean(inputError.tags)}
          helperText={t(inputError.tags)}
          multiple
          renderValue={(selected) =>
            selected.map((item) => {
              const found = allEcommerceTags.find((tag) => tag.value === item);
              if (!found) return null;
              return (
                <Chip
                  key={item.value}
                  label={found.label[currentLanguage]}
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                    marginRight: 0.5,
                    marginBottom: 0.5,
                  }}
                  onMouseDown={(e) => e.stopPropagation()}
                  onDelete={(e) => {
                    e.stopPropagation();
                    handleDeleteTag(item);
                  }}
                />
              );
            })
          }
        >
          <MenuItem value="" disabled>
            {t("supplierProductTab.selectMultipleMatchFit")}
          </MenuItem>
          {allEcommerceTags.map((item, index) => {
            const isSelected = inputValues.tags.includes(item.value);
  
            return (
              <MenuItem
                key={index}
                value={item.value}
                sx={{ textTransform: "capitalize", paddingX: "8px" }}
              >
                <ListItemIcon sx={{ minWidth: 20 }}>
                  {isSelected && (
                    <CheckIcon fontSize="small" htmlColor="#7922D8" />
                  )}
                </ListItemIcon>
                {item.label[currentLanguage]}
              </MenuItem>
            );
          })}
        </CustomDropDown>
      </Box>
    );
  };